export function devMode(): boolean {
  return process.env.NODE_ENV === 'development'
}

/**
 * We use this to discover mutations that would cause bugs elsewhere.
 * If you encounter a problem with this, then consider copying the object and mutating that copy.
 */
export function freezeInDevMode<T extends Object>(obj: T): T {
  if (devMode()) {
    return Object.freeze(obj)
  } else {
    return obj
  }
}
